import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EmptyState, History, HistoryItem } from "./points-history.style";
import { OrderNowCTA } from "@/components/account/rewards/orderNowCTA";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { Modal } from "@/components/uielements/modal";
import { StyledPrimaryButton } from "@/components/uielements/primaryButton/styles";
import {
  StyledRewardsButtonHeader,
  StyledRewardsFooterBox,
} from "@/components/uielements/reward/styles";
import { CSS_CLASSES } from "@/constants/cssClassNames";
import { DATE_FORMAT } from "@/constants/dates";
import meActions from "@/redux/me/actions";
import { type RootState } from "@/types/app";
import { formatDate } from "@/utils/dates";

export const PointsHistory = () => {
  const rewardsHistory = useSelector(
    (state: RootState) => state.app.me.rewardsHistory
  );
  const dispatch = useDispatch();

  const hasRewards = rewardsHistory.length > 0 ? true : false;

  useEffect(() => {
    dispatch(meActions.fetchRewardsHistory());
  }, []);

  return (
    <StyledRewardsFooterBox
      className={CSS_CLASSES.LOYALTY_REWARDS_FOOTER.POINTS_HISTORY}
    >
      <StringAccessor
        tag={StyledRewardsButtonHeader}
        accessor="rewards.point_history_header"
      />

      <Modal.Container
        trigger={(open) => (
          <StyledPrimaryButton
            onClick={open}
            buttonTheme="knockout"
            aria-label="Click to view your points history"
          >
            <StringAccessor accessor="rewards.point_history_button" />
          </StyledPrimaryButton>
        )}
      >
        {() => (
          <>
            <Modal.Title>
              <StringAccessor
                accessor="rewards.point_history_modal_header"
                html={true}
              />
            </Modal.Title>

            <Modal.Content>
              {hasRewards ? (
                <History>
                  {rewardsHistory.map(
                    (item, index) =>
                      item.value && (
                        <HistoryItem
                          key={`${item.date}-${index}`}
                          addition={item.value.indexOf("+") > -1}
                        >
                          <h3>
                            {formatDate(item.date, DATE_FORMAT.MONTH_DAY_YEAR)}
                          </h3>
                          <h2>{item.value}</h2>
                        </HistoryItem>
                      )
                  )}
                </History>
              ) : (
                <EmptyState>
                  <StringAccessor
                    tag="h3"
                    accessor="rewards.points_history_modal_empty_header"
                    html={true}
                  />
                  <StringAccessor
                    tag="p"
                    accessor="rewards.points_history_modal_empty_subheader"
                    html={true}
                  />
                </EmptyState>
              )}
            </Modal.Content>

            <Modal.Footer>
              <Modal.Cancel>Close</Modal.Cancel>

              {!hasRewards && <OrderNowCTA label="Rewards - History Modal" />}
            </Modal.Footer>
          </>
        )}
      </Modal.Container>
    </StyledRewardsFooterBox>
  );
};
